import { useMutation, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { DefaultResponseWithData } from "../models/system";
import {
  AccountAddressCreateEditRequest,
  IAccountAddress,
} from "../models/account/IAccountAddress";
import apiConfig from "../utils/apiConfig";

export default function useAccountAddressMutations(
  accountId?: string,
  addressId?: string,
  componentName = "useAccountAddressMutations"
) {
  const { put } = useApiHelper(apiConfig(componentName));
  const queryClient = useQueryClient();

  const update = useMutation({
    mutationFn: (data: AccountAddressCreateEditRequest) =>
      put<
        AccountAddressCreateEditRequest,
        DefaultResponseWithData<IAccountAddress>
      >(`/account/${accountId}/address/${addressId}`, data),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: ["accounts", accountId, "addresses"],
      }),
  });

  return {
    update,
  };
}
